<!-- Logo may be bitmap too, but SVG is recommended. Any size is possible. It will be clamped to 2rem in height (with width scaled to keep aspect). -->
<div class="position-relative">
  <img src="{{logo}}" class="img-logo" alt="Logo">
  <span class="nav-name">PDP</span>
</div>
